import { render } from "./IceCalendar.vue?vue&type=template&id=49ade792&scoped=true"
import script from "./IceCalendar.vue?vue&type=script&lang=js"
export * from "./IceCalendar.vue?vue&type=script&lang=js"

import "./IceCalendar.vue?vue&type=style&index=0&id=49ade792&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ade792"]])

export default __exports__